import Icon from '../components/Icon.vue'

Icon.register({
  'chart-bar': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M332.8 320H371.2C377.6 320 384 313.6 384 307.2V172.8C384 166.4 377.6 160 371.2 160H332.8C326.4 160 320 166.4 320 172.8V307.2C320 313.6 326.4 320 332.8 320zM428.8 320H467.2C473.6 320 480 313.6 480 307.2V76.8C480 70.4 473.6 64 467.2 64H428.8C422.4 64 416 70.4 416 76.8V307.2C416 313.6 422.4 320 428.8 320zM140.8 320H179.2C185.6 320 192 313.6 192 307.2V236.8C192 230.4 185.6 224 179.2 224H140.8C134.4 224 128 230.4 128 236.8V307.2C128 313.6 134.4 320 140.8 320zM236.8 320H275.2C281.6 320 288 313.6 288 307.2V108.8C288 102.4 281.6 96 275.2 96H236.8C230.4 96 224 102.4 224 108.8V307.2C224 313.6 230.4 320 236.8 320zM496 384H64V80C64 71.2 56.8 64 48 64H16C7.2 64 0 71.2 0 80V416C0 433.7 14.3 448 32 448H496C504.8 448 512 440.8 512 432V400C512 391.2 504.8 384 496 384z'
      }
    ]
  }
})
